/**
 * A numeric id from a select, as a number or nothing.
 *
 * `SelectInputWithKeyValue` emits `event.target.value`, and a select's value is always a string, while the
 * fields behind these selects are declared `number | null`. Its emit is the untyped `defineEmits([...])`
 * array form, so the payload is `any` and TypeScript catches none of it — which is how a string came to sit
 * in `buildingTypeEnum` for a whole session with `vue-tsc` clean throughout. Note it has no `cast` prop,
 * unlike `SelectInputNew`; passing one is silently ignored.
 *
 * Takes `unknown` on purpose: the whole point is that the caller cannot trust what it was handed.
 */
export const toSelectedNumberId = (value: unknown): number | null => {
  // The placeholder option's value is the empty string, which means "nothing chosen" and must not become 0.
  if (value === null || value === undefined || value === "") return null;

  const asNumber = Number(value);
  return Number.isNaN(asNumber) ? null : asNumber;
};

/**
 * The building type reading of the same coercion, kept as its own name because that is what its callers
 * are talking about and because the bug it exists for was specifically a string building type.
 */
export const toBuildingTypeId = toSelectedNumberId;
